import React from 'react';
import PropTypes from 'prop-types';
import css from './Phone.scss';
import preferenceCss from './PreferencesSection.scss';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import classnames from 'classnames';
import { isEmptyString } from 'utils/text';

/**
 * @param {string} labelledById - the id of the corresponding label element
 * @param {function} onChange - called when the value of the input is changed
 * @param {string} value - the existing phone number
 * @param {function} validateCountry - optionally provides validation on selected country
 * @returns {node} a custom phone input component.
 */
const Phone = ({ extraCss, labelledById, onChange, value, validateCountry = () => {} }) => {
    return (
        <div className={classnames(css.phone, preferenceCss['fake-input'], {[extraCss]: !isEmptyString(extraCss)})}>
            <PhoneInput defaultCountry="US"
                        displayInitialValueAsLocalNumber={false}
                        numberInputProps={{'aria-labelledby': labelledById}}
                        onChange={onChange}
                        onCountryChange={(country) => validateCountry(country)}
                        value={value} />
        </div>
    );
};

Phone.propTypes = {
    extraCss: PropTypes.string,
    labelledById: PropTypes.string,
    onChange: PropTypes.func,
    validateCountry: PropTypes.func,
    value: PropTypes.string
};

export default Phone;
